/**
 * New stock transfer route — mounts `<StockTransferComposerPage />`.
 *
 * @see apps/web/src/features/inventory/stock/stock-transfers-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { StockTransferComposerPage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock-transfers/new")({
  component: NewStockTransferRoute,
});

function NewStockTransferRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Transfers", to: "/inventory/stock-transfers" },
        { label: "New" },
      ]}
      disableViewportScroll
      contentClassName="max-w-none h-full"
      viewportClassName="p-0"
    >
      <StockTransferComposerPage />
    </WorkspaceShell>
  );
}
